// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__5DVTl","location":"Header_location__36ezK"};